import { Box, HStack } from '@chakra-ui/react';

import { useMediaQueries } from 'layout/MediaQueriesProvider';

import useSandboxTheme from '../useSandboxTheme';

const GuideIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <circle cx="12" cy="12" r="10" />
    <path d="M12 2a14.5 14.5 0 0 0 0 20" />
    <path d="M12 2a14.5 14.5 0 0 1 0 20" />
    <path d="M2 12h20" />
  </svg>
);

interface ITourPillProps {
  isProminent: boolean;
  isActive: boolean;
  onClick: () => void;
}

const TourPill = ({ isProminent, isActive, onClick }: ITourPillProps) => {
  const { isMobile } = useMediaQueries();
  const { colors, isLight } = useSandboxTheme();

  if (isMobile) return null;

  const prominentBorder = 'linear-gradient(90deg, rgba(159, 122, 234, 0.87), rgba(237, 137, 54, 0.87))';

  return (
    <Box
      as="button"
      onClick={onClick}
      height="28px"
      px="10px"
      borderRadius="14px"
      display="flex"
      alignItems="center"
      cursor="pointer"
      transition="all 0.15s ease-out"
      position="relative"
      bg={
        isActive
          ? 'purple.400'
          : isProminent
            ? 'transparent'
            : isLight ? 'blackAlpha.50' : 'whiteAlpha.50'
      }
      color={
        isActive
          ? 'gray.900'
          : isProminent
            ? colors.textSecondary
            : colors.textMuted
      }
      border="1px solid"
      borderColor={isActive ? 'purple.400' : isProminent ? 'transparent' : isLight ? 'blackAlpha.100' : 'whiteAlpha.100'}
      _hover={{
        bg: isActive ? 'purple.500' : isLight ? 'blackAlpha.100' : 'whiteAlpha.200',
        color: isActive ? 'gray.900' : colors.textSecondary,
      }}
      sx={
        isProminent && !isActive
          ? {
              _before: {
                content: '""',
                position: 'absolute',
                inset: '-1px',
                borderRadius: '14px',
                padding: '1px',
                background: prominentBorder,
                WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                WebkitMaskComposite: 'xor',
                maskComposite: 'exclude',
              },
              '@keyframes tourPillGlow': {
                '0%, 100%': { opacity: 0.5 },
                '50%': { opacity: 1 },
              },
              animation: 'tourPillGlow 2s ease-in-out infinite',
            }
          : {}
      }
    >
      <HStack spacing="6px">
        <Box as="span" display="flex">
          <GuideIcon />
        </Box>
        <Box as="span" fontSize="11px" fontWeight="500" lineHeight="1" whiteSpace="nowrap">
          Tour
        </Box>
      </HStack>
    </Box>
  );
};

export default TourPill;
